import React from "react";

export default function Section(props) {
    return (
      <section>
        <div className="Image">
          <img src={props.url} alt={props.alt} />
        </div>
  
        <div className="Infos">
          <h1>{props.title}</h1>
          <h2>{props.titulos}</h2>
        </div>
      </section>
    );
  }
  